import React from 'react';
import { IIconProps } from './IIconProps';

export const PlayIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 10 12"
			className={iconClass}
			fill="none"
			stroke="#fff"
		>
			{title && <title>{title}</title>}
			<path d="M9.25 5.56699C9.58333 5.75944 9.58333 6.24056 9.25 6.43301L1.75 10.7631C1.41667 10.9556 1 10.715 1 10.3301L1 1.66987C1 1.28497 1.41667 1.04441 1.75 1.23686L9.25 5.56699Z" />
		</svg>
	);
};
// <svg width="10" height="12" viewBox="0 0 10 12" fill="none"
// xmlns="http://www.w3.org/2000/svg"> <path d="M9.25 5.56699C9.58333 5.75944
// 9.58333 6.24056 9.25 6.43301L1.75 10.7631C1.41667 10.9556 1 10.715 1
// 10.3301L1 1.66987C1 1.28497 1.41667 1.04441 1.75 1.23686L9.25 5.56699Z"
// stroke="white"/> </svg>
